import microuniversoApi from "app/api/microuniversoApi"
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { IOrcamento } from "app/types/IOrcamento"
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'


import globalMU from "globalMU"

declare var window:any

export type DefinirPercentualSeguroEntregaInput = {
    percentualSeguroEntrega: number
}

export async function definirPercentualSeguroEntrega(input: DefinirPercentualSeguroEntregaInput) {
    
    try {
        globalMU.blockUI()
        
        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirPercentualSeguroEntrega(
            store.getState().orcamento.IdentificadorOrcamento,
            input.percentualSeguroEntrega
        )
    
        
    
        const atualizarEstado = () => {
            const orcamentoLegado = window.orcamentoController.model

            orcamentoLegado.atualizar(orcamentoAtualizado, true, true)

            store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado))
        }
    
        
        atualizarEstado()
    } finally {
        globalMU.unblockUI()
    }
}